// preloadVariants.js
// Secure preload of article groups + article types (CP-style global variables)

export async function preloadVariantData() {
  console.log("Preloading article groups & types...");

  const apiKey = localStorage.getItem("api_key");

  // Skip preload entirely if no API key (prevents 403 spam on login page)
  if (!apiKey) {
    console.warn("⚠ No API key found — skipping variant preload");
    return;
  }

  // Use Vite dev proxy and backend prefix: /api/...
  const API_BASE = "/api";

  try {
    const headers = {
      "Content-Type": "application/json",
      "x-api-key": apiKey
    };

    // Fetch groups + types in parallel
    const [groupsRes, typesRes] = await Promise.all([
      fetch(`${API_BASE}/article-groups`, { headers }),
      fetch(`${API_BASE}/article-types`, { headers })
    ]);

    if (!groupsRes.ok) {
      const msg = await groupsRes.text();
      throw new Error("Groups fetch failed: " + msg);
    }

    if (!typesRes.ok) {
      const msg = await typesRes.text();
      throw new Error("Types fetch failed: " + msg);
    }

    const groups = await groupsRes.json();
    const types = await typesRes.json();

    // Store globally (ComfortPages pattern)
    window.nz_articleGroups = groups;
    window.nz_articleTypes = types;

    console.log("✔ Variant data loaded:", {
      groups: groups.length,
      types: types.length
    });

  } catch (err) {
    console.error("❌ Failed to preload variant data:", err);
  }
}
